import React from 'react';
type IconComponent = React.ComponentType<{
  className?: string;
  'aria-hidden'?: boolean;
}>;
interface SectionHeadingProps {
  badge?: string;
  badgeIcon?: IconComponent;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  id?: string;
  tone?: 'dark' | 'light';
}

/** Italic green accent used inside section titles. */
export function Accent({
  children
}: {
  children: React.ReactNode;
}) {
  return <em className="italic text-forest-400" data-id="element-161" data-mp="bjty7ykaos36">{children}</em>;
}
export function SectionHeading({
  badge,
  badgeIcon: BadgeIcon,
  title,
  subtitle,
  id,
  tone = 'dark'
}: SectionHeadingProps) {
  const titleColor = tone === 'dark' ? 'text-forest-800' : 'text-cream-50';
  const subColor = tone === 'dark' ? 'text-forest-700/70' : 'text-cream-100/75';
  return <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-162" data-mp="6raj2x5ylow9">
      {badge ? <span className="inline-flex items-center gap-2 rounded-full bg-cream-200 px-5 py-2 text-[0.7rem] font-bold uppercase tracking-[0.16em] text-forest-700" data-id="element-163" data-mp="uhelj17evilo">
          {BadgeIcon ? <BadgeIcon className="h-3.5 w-3.5 text-ember-500" aria-hidden={true} data-id="element-164" data-mp="1tah63l1jub5p" /> : null}
          {badge}
        </span> : null}
      <h2 id={id} className={`${badge ? 'mt-4' : ''} font-display text-3xl font-bold leading-[1.15] sm:text-4xl lg:text-[2.9rem] ${titleColor}`} data-id="element-165" data-mp="22zsaiudhqrn9">
        {title}
      </h2>
      {subtitle ? <p className={`mt-4 text-base leading-relaxed sm:text-lg ${subColor}`} data-id="element-166" data-mp="2c06vttqgg6qr">{subtitle}</p> : null}
    </div>;
}